export default "__VITE_ASSET__7bd3e0a7__"